export {debounce} from 'debounce';

import Component from '../component/component';

import './helpers.scss';

export type DebouncedFunction<F> = F & { clear(): void } & { flush(): void };

export interface IGaEventParams {
    category: string;
    action: string;
    label?: string;
    value?: number;
}

export default class Helpers {

    static defaults: IGotoAndPlay = {
        ajax: {
            isEnabled: false,
            keptBodyClasses: [],
            templateName: '',
        },
        ajaxPath: '',
        assetsPath: '',
        components: {},
        cookieDomain: '',
        cookiePath: '',
        headerOffset: 0,
        lightboxApiKey: 'W5ZTE-CNJCG-6ARFR-HNSBU',
        lightboxLoaded: false,
        loggedIn: false,
        nonce: '',
        notifications: [],
        sitePath: '',
        svgPath: '',
        templatePath: '',
        version: '',
        vimeoApiLoaded: false,
    };

    /* eslint-disable */ // this lets the breakpoints stay in numerical order, not alphabetical
    static bp: {[key: string]: number} = {
        xs: 360,
        sm: 479,
        md: 768,
        lg: 1089,
        xl: 1301,
    };
    /* eslint-enable */

    static scrollToTarget(target: HTMLElement, offsetTop: number = 0): void {
        const header: HTMLElement = document.querySelector('.header');
        let headerHeight: number = 0;

        if (header !== undefined && header !== null) {
            headerHeight = header.offsetHeight;
        }

        const scrollTop: number = target.offsetTop - offsetTop - headerHeight;

        scroll({
            behavior: 'smooth',
            top: scrollTop,
        });
    }

    static disableScroll(): void {
        if (!Helpers.isScrollDisabled()) {
            const curScroll: number = window.scrollY;
            const page: HTMLElement = document.getElementById('page');

            document.body.classList.add('is-scroll-disabled');
            if (page) {
                page.style.top = -curScroll + 'px';
            }

            window.scrollTo(0, 0);
        }
    }

    static enableScroll(): void {
        const page: HTMLElement = document.getElementById('page');
        const bodyScroll: number = page ? parseInt((page.style.top || '0'), 10) : 0;

        document.body.classList.remove('is-scroll-disabled');
        if (bodyScroll) {
            window.scrollTo(0, -bodyScroll);

            if (page) {
                page.style.top = '0px';
            }
        }
    }

    static isScrollDisabled(): boolean {
        return document.body.classList.contains('is-scroll-disabled');
    }

    static get isIE(): boolean | number {

        const ua: string = window.navigator.userAgent;
        const msie: number = ua.indexOf('MSIE ');

        if (msie > 0) {
            // IE 10 or older => return version number

            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        const trident: number = ua.indexOf('Trident/');

        if (trident > 0) {
            // IE 11 => return version number
            const rv: number = ua.indexOf('rv:');

            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        const edge: number = ua.indexOf('Edge/');

        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }

        // other browser

        return false;
    }

    static init(): void {
        // setup defaults variables
        Object.keys(Helpers.defaults).forEach((key: string): void => {
            if (window.gotoAndPlay[key] === undefined) {
                window.gotoAndPlay[key] = Helpers.defaults[key];
            }
        });
        // run after document ready
        document.addEventListener('DOMContentLoaded', (): void => {
            // init components
            if (window.gotoAndPlay && Object.prototype.hasOwnProperty.call(window.gotoAndPlay, 'components')) {
                Object.keys(window.gotoAndPlay.components).forEach((name: string): void => {
                    const component: unknown = window.gotoAndPlay.components[name];

                    if (Component.is(component)) {
                        component.enhance();
                    }
                });
                document.dispatchEvent(new CustomEvent('enhance'));
            }
        });

        document.addEventListener('click', (event: Event) => {
            const target: HTMLElement = event.target as HTMLElement;

            if (target.classList.contains('js-scroll-to')) {
                event.preventDefault();
                const targetSection: HTMLElement = document.querySelector(target.getAttribute('href'));

                Helpers.scrollToTarget(targetSection);
            }
        });

        // Calc app height
        document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);

        window.addEventListener('resize', () => {
            document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
        });
    }
}

Helpers.init();
